import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { QueryAtomResult } from '~/shared/providers/api/createQueryAtomFactory';

export type InvoiceRecord = QueryAtomResult<typeof invoicesAtom>[number];

export const invoiceIdsByBookingAtom = createQueryAtomFactory(
  'customerPortal.invoiceIdsByBookingIds',
  (params: { bookingIds?: string[] }) => ({
    loads: {
      __args: {
        filter: {
          bookingIds: params.bookingIds,
        },
      },
      entries: {
        id: true,
        reconciliation: {
          invoiceId: true,
        },
      },
    },
  }),
  {
    select: ({ loads }) =>
      loads.entries
        .map((load) => load.reconciliation?.invoiceId)
        .filter(Boolean) as string[],
  },
);

export const invoicesAtom = createQueryAtomFactory(
  'customerPortal.invoices',
  (params: { invoiceIds: string[] }) => ({
    invoices: {
      __args: {
        filter: {
          ids: params.invoiceIds,
        },
      },
      entries: {
        id: true,
        documentNumber: true,
        amount: {
          amount: true,
          currencyCode: true,
        },
      },
    },
  }),
  {
    select: ({ invoices }) =>
      invoices.entries.map((it) => ({
        id: it.id,
        documentNumber: it.documentNumber,
        amount: it.amount,
      })),
  },
);
